import { StyleSheet } from 'react-native';

export default StyleSheet.create({
    confirmWrapper: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, .6)',
        justifyContent: 'center',
        alignItems: 'center'
    },
    modalWrap:{
        width: 296,
        height: 359,
        justifyContent: 'center',
        alignItems: 'center',
        position:'relative'
    },
    cardWrap:{
        position:'absolute',
        top:172,
        left:24,
        flexDirection:'column'
    },
    textWrap:{
        width:248,
        flexDirection:'row',
        paddingLeft:12,
        paddingRight:12
    },
    typeKey:{
        lineHeight:20,
        fontFamily:'PingFangSC-Regular',
        fontSize:12,
        color:"#999"
    },
    typeValue:{
        lineHeight:20,
        fontFamily:'PingFangSC-Regular',
        fontSize:12,
        color:"#333"
    },
    closeWrap:{
        position:'absolute',
        top:0,
        right:0,
        width: 36,
        height: 36
    },
    closeBtn:{
        width: '100%',
        height: '100%'
    }
});
